import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logout, authorizeMentorToken } from "../../../actions/auth";
import { setAlert } from "../../../actions/alert";
import RedLogo from "./RedLogo";

const TwoFARequestMentor = ({
  authorizeMentorToken,
  setAlert,
  logout,
  setShowAuthentication,
  channelid,
  jobtitle,
  location,
}) => {
  const [formData, setFormData] = useState({
    token: "",
  });

  const { token } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (token === "") {
      setAlert("Please enter a valid token");
    }
    authorizeMentorToken(token, channelid);
  };

  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() => {
              logout();
              setShowAuthentication(false);
            }}
          ></i>
          <div className="flex-center">
            <div className="index-logo-alt">
              <RedLogo />
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">{channelid}</span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Enter the code found in your authenticator app, or you can request
            the code via SMS. If you've lost your phone, please contact{" "}
            <span className="red bold">ime Support</span>.
          </div>
          <form
            className="form-control"
            method="POST"
            onSubmit={(e) => onSubmit(e)}
          >
            <label htmlFor="email" className="token-labels-input red">
              *Token:
            </label>
            <input
              className="forgot-password-input"
              type="text"
              name="token"
              placeholder="Enter Token"
              onChange={(e) => onChange(e)}
            />
            <div className="flex-center">
              <button
                className="user-request-button background-red"
                // onClick={() =>
                //   sendUserRequest({ user }) &&
                //   casualNotification(match.params.channelid) &&
                //   setrequestoverlay({ request: false, confirm: true })
                // }
              >
                <i className="far fa-check-circle fa-sm mr-5"></i>
                Submit
              </button>
              <button
                className="user-request-button background-red"
                // onClick={() =>
                //   setrequestoverlay({ request: false, confirm: false })
                // }
              >
                <i className="fa-solid fa-mobile fa-sm mr-5 bold"></i>
                Request SMS
              </button>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

TwoFARequestMentor.propTypes = {
  auth: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  authorizeMentorToken,
  logout,
  setAlert,
})(TwoFARequestMentor);
